/* LBCustom — don lai dong bundle trong gio hang / cart drawer.
 *
 * Khi mot dong co ten khach, Cart Transform no no thanh bundle [tui + phi], va theme
 * Horizon in ra danh sach thanh phan:
 *     "The Odyssey" Leather Handbag          <- tieu de dong (theme tu in)
 *     "The Odyssey" Leather Handbag - M / …  <- thanh phan 1 (lap lai tieu de)
 *     Personalization                        <- thanh phan 2 (khach khong can biet)
 *     Name: ABCD                             <- thuoc tinh, cai nay moi la thu khach can
 *
 * Nen o day: bo dong "Personalization", va cat phan tieu de lap lai o thanh phan 1 cho
 * chi con "M / Premium Vegan Leather" — doc y het dong hang binh thuong.
 *
 * Chay toan site vi cart drawer mo duoc o moi trang. Dung MutationObserver rieng, khong
 * dung chung voi litborne-summer26.js de khong dung vao phan trang tri gia dang chay.
 */
(function () {
  var TEN_PHI = /^personalization\b/i;

  function don() {
    var ds = document.querySelectorAll('ul.cart-items__bundle:not([data-lbc])');
    for (var i = 0; i < ds.length; i++) {
      var ul = ds[i];
      var li = ul.querySelectorAll('li');
      if (li.length < 2) continue;

      /* Tieu de dong nam o .cart-items__title ngay tren danh sach nay. */
      var hang = ul.closest('.cart-items__product-info') || ul.parentNode;
      var tdEl = hang && hang.querySelector('.cart-items__title');
      var td = tdEl ? tdEl.textContent.trim() : '';

      for (var j = 0; j < li.length; j++) {
        var t = li[j].textContent.trim();
        if (TEN_PHI.test(t)) { li[j].remove(); continue; }
        /* '<tieu de> - M / Premium Vegan Leather' -> 'M / Premium Vegan Leather' */
        if (td && t.indexOf(td) === 0) {
          var con = t.slice(td.length).replace(/^\s*[-–—]\s*/, '');
          if (con) li[j].textContent = con;
        }
      }
      ul.setAttribute('data-lbc', '1');
    }
  }

  don();
  if (window.MutationObserver) {
    new MutationObserver(don).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('cart:update', don);
})();
